import { BiometryValidationStepComponent } from './biometry-validation-step/biometry-validation-step.component';
import { CreditRequestDetailComponent } from './credit-request-detail/credit-request-detail.component';

import { CompanyAddressInformationStepComponent } from './company-address-information-step/company-address-information-step.component';
import { CompanyBankReferencesStepComponent } from './company-bank-references-step/company-bank-references-step.component';
import { CompanyContactInformationStepComponent } from './company-contact-information-step/company-contact-information-step.component';
import { CompanyInformationStepComponent } from './company-information-step/company-information-step.component';
import { CreateCreditRequestComponent } from './create-credit-request/create-credit-request.component';
import { CreditRequestListComponent } from './credit-request-list/credit-request-list.component';
import { CreditRequestSaveStepComponent } from './credit-request-save-step/credit-request-save-step.component';
// import { DocumentsStepComponent } from './documents-step/documents-step.component';
import { BankRepresentativeStepComponent } from './bank-representative-step/bank-representative-step.component';
import { FranchisedCreditPlanStepperComponent } from './franchised-credit-plan-stepper/franchised-credit-plan-stepper.component';
import { GeneralInformationStepComponent } from './general-information-step/general-information-step.component';
import { LegalEntityCreditPlanStepperComponent } from './legal-entity-credit-plan-stepper/legal-entity-credit-plan-stepper.component';
import { LegalEntityThirtyDaysPlanStepperComponent } from './legal-entity-thirty-days-plan-stepper/legal-entity-thirty-days-plan-stepper.component';
import { ModifyCreditRequestComponent } from './modify-credit-request/modify-credit-request.component';
import { ObservationsStepComponent } from './observations-step/observations-step.component';
import { PersonAddressInformationStepComponent } from './person-address-information-step/person-address-information-step.component';
import { PersonAgreementPlanStepperComponent } from './person-agreement-plan-stepper/person-agreement-plan-stepper.component';
import { PersonCreditAnalysisPlanStepperComponent } from './person-credit-analysis-plan-stepper/person-credit-analysis-plan-stepper.component';
import { PersonEmployeePlanStepperComponent } from './person-employee-plan-stepper/person-employee-plan-stepper.component';
import { PersonFastTrackPlanStepperComponent } from './person-fast-track-plan-stepper/person-fast-track-plan-stepper.component';
import { PersonGuaranteedPlanStepperComponent } from './person-guaranteed-plan-stepper/person-guaranteed-plan-stepper.component';
import { PersonImmediateProcedurePlanStepperComponent } from './person-immediate-procedure-plan-stepper/person-immediate-procedure-plan-stepper.component';
import { IndependentIncomeComponent } from './person-income-information-step/incomes/independent-income/independent-income.component';
import { OthersIncomeComponent } from './person-income-information-step/incomes/others-income/others-income.component';
import { RemittanceIncomeComponent } from './person-income-information-step/incomes/remittance-income/remittance-income.component';
import { SalariedIncomeComponent } from './person-income-information-step/incomes/salaried-income/salaried-income.component';
import { PersonIncomeInformationStepComponent } from './person-income-information-step/person-income-information-step.component';
import { PersonInformationStepComponent } from './person-information-step/person-information-step.component';
import { PersonNormalPlanStepperComponent } from './person-normal-plan-stepper/person-normal-plan-stepper.component';
import { PersonReferencesInformationStepComponent } from './person-references-information-step/person-references-information-step.component';


export const components = [
  CreateCreditRequestComponent,
  CreditRequestListComponent,
  ModifyCreditRequestComponent,
  LegalEntityCreditPlanStepperComponent,
  GeneralInformationStepComponent,
  CompanyInformationStepComponent,
  CompanyAddressInformationStepComponent,
  CompanyContactInformationStepComponent,
  CompanyBankReferencesStepComponent,
  ObservationsStepComponent,
  // DocumentsStepComponent,
  CreditRequestSaveStepComponent,
  LegalEntityThirtyDaysPlanStepperComponent,
  PersonCreditAnalysisPlanStepperComponent,
  PersonInformationStepComponent,
  PersonAddressInformationStepComponent,
  PersonIncomeInformationStepComponent,
  SalariedIncomeComponent,
  IndependentIncomeComponent,
  RemittanceIncomeComponent,
  OthersIncomeComponent,
  PersonReferencesInformationStepComponent,
  PersonImmediateProcedurePlanStepperComponent,
  CreditRequestDetailComponent,
  PersonFastTrackPlanStepperComponent,
  PersonGuaranteedPlanStepperComponent,
  PersonNormalPlanStepperComponent,
  PersonAgreementPlanStepperComponent,
  PersonEmployeePlanStepperComponent,
  BankRepresentativeStepComponent,
  FranchisedCreditPlanStepperComponent,
  BiometryValidationStepComponent
];

export * from './company-address-information-step/company-address-information-step.component';
export * from './company-bank-references-step/company-bank-references-step.component';
export * from './company-contact-information-step/company-contact-information-step.component';
export * from './company-information-step/company-information-step.component';
export * from './create-credit-request/create-credit-request.component';
export * from './credit-request-detail/credit-request-detail.component';
export * from './credit-request-list/credit-request-list.component';
export * from './credit-request-save-step/credit-request-save-step.component';
// export * from './documents-step/documents-step.component';
export * from './bank-representative-step/bank-representative-step.component';
export * from './biometry-validation-step/biometry-validation-step.component';
export * from './franchised-credit-plan-stepper/franchised-credit-plan-stepper.component';
export * from './general-information-step/general-information-step.component';
export * from './legal-entity-credit-plan-stepper/legal-entity-credit-plan-stepper.component';
export * from './legal-entity-thirty-days-plan-stepper/legal-entity-thirty-days-plan-stepper.component';
export * from './modify-credit-request/modify-credit-request.component';
export * from './observations-step/observations-step.component';
export * from './person-address-information-step/person-address-information-step.component';
export * from './person-agreement-plan-stepper/person-agreement-plan-stepper.component';
export * from './person-credit-analysis-plan-stepper/person-credit-analysis-plan-stepper.component';
export * from './person-employee-plan-stepper/person-employee-plan-stepper.component';
export * from './person-fast-track-plan-stepper/person-fast-track-plan-stepper.component';
export * from './person-guaranteed-plan-stepper/person-guaranteed-plan-stepper.component';
export * from './person-immediate-procedure-plan-stepper/person-immediate-procedure-plan-stepper.component';
export * from './person-income-information-step/incomes/independent-income/independent-income.component';
export * from './person-income-information-step/incomes/others-income/others-income.component';
export * from './person-income-information-step/incomes/remittance-income/remittance-income.component';
export * from './person-income-information-step/incomes/salaried-income/salaried-income.component';
export * from './person-income-information-step/person-income-information-step.component';
export * from './person-information-step/person-information-step.component';
export * from './person-normal-plan-stepper/person-normal-plan-stepper.component';
export * from './person-references-information-step/person-references-information-step.component';

